export const translations = {
	nav: {
		title: 'Navegação',
		app: 'Certificado de doação',
	},
	footer: {
		poweredBy: 'Feito por',
		copyright: '© {{year}} WorldCoo. Todos os direitos reservados.',
		termsAndConditions: 'Termos e condições',
		privacyPolicy: 'Política de privacidade',
	},
	categories: {
		basicNeeds: 'Água e Energia',
		humanRights: 'Direitos Humanos',
		education: 'Educação',
		emergency: 'Emergências',
		feeding: 'Fome e Segurança Alimentar',
		environment: 'Meio Ambiente',
		habitat: 'Habitação e Pobreza',
		health: 'Saúde',
	},
	statistics: {
		campaigns: 'Campanhas',
		donations: 'Doações',
		collected: 'Arrecadado',
		collectedFromBudget: 'Objetivo de {{budget}}',
	},
	filters: {
		year: 'Ano',
		state: 'Estado',
		cause: 'Causa',
		active: 'Ativa',
		finished: 'Finalizada',
		default: 'Por padrão',
		toggle: 'Alternar {{value}}',
	},
	actions: {
		close: 'Fechar',
		search: 'Buscar qualquer coisa',
		filter: 'Filtrar',
		viewCampaign: 'Ver campanha',
		makeDonation: 'Fazer doação',
		donate: 'Doar',
		selectLanguage: 'Selecionar idioma',
		backToHome: 'Voltar para a página inicial',
		funded: 'Financiado',
		clear: 'Limpar Filtros',
		apply: 'Aplicar',
		goBack: 'Voltar',
		previous: 'Anterior',
		next: 'Próximo',
	},
	portal: {
		heroButton: 'Comece a doar',
		campaigns: {
			title: 'Campanhas',
			description: 'Explore nossas iniciativas e escolha a causa que mais te inspira',
			notFound: 'Nenhuma campanha',
		},
		campaignFunded: 'Campanha financiada',
		percentageFunded: '{{percentage}}% Financiada',
		aCampaignFrom: 'Uma campanha de: {{ngoName}}',
		beneficiaries: 'Beneficiários',
		directBeneficiaries: '{{count}} diretos',
		indirectBeneficiaries: '{{count}} indiretos',
		sdgs: {
			title: 'Objetivos de Desenvolvimento Sustentável',
			1: 'Erradicação da Pobreza',
			2: 'Fome Zero',
			3: 'Saúde e Bem-Estar',
			4: 'Educação de Qualidade',
			5: 'Igualdade de Género',
			6: 'Água Potável e Saneamento',
			7: 'Energias Renováveis e Acessíveis',
			8: 'Trabalho Digno e Crescimento Económico',
			9: 'Indústria, Inovação e Infraestruturas',
			10: 'Reduzir as Desigualdades',
			11: 'Cidades e Comunidades Sustentáveis',
			12: 'Produção e Consumo Sustentáveis',
			13: 'Ação Climática',
			14: 'Vida na Água',
			15: 'Vida Terrestre',
			16: 'Paz, Justiça e Instituições Eficazes',
			17: 'Parcerias para a Implementação dos Objetivos',
		},
	},
	faq: {
		title: 'Perguntas frequentes',
		description: 'Respostas às dúvidas mais comuns dos nossos doadores.',
	},
	campaign: {
		objectives: 'Objetivos da campanha',
		description: 'Descrição',
		activities: 'Atividades',
		beneficiaries: 'Quem será beneficiado?',
		updatesAndLinks: 'Mais informações e links',
		from: 'De:',
		until: 'Até:',
	},
	campaigns: {
		notTranslated: 'Este projeto ainda não está disponível no seu idioma.',
	},
	placeholders: {
		amount: 'Outro valor',
	},
	donate: {
		title: 'Faça sua doação',
		details: {
			title: 'Adicione seus dados para continuar',
			subtitle:
				'Complete seus dados para finalizar sua doação. Você também pode solicitar seu certificado fiscal aqui.',
		},
		certificate: {
			title: 'Recupere até {{amount}}',
			subtitle:
				'Certifique sua doação com um clique e ela aparecerá automaticamente no rascunho da sua declaração de imposto de renda.',
		},
	},
	errors: {
		required: 'Este campo é obrigatório',
		invalidExtref: 'O código é inválido, deve seguir este formato: {{format}}',
		email: 'O endereço de e-mail está mal formatado.',
		emailAlreadyExists: 'Este e-mail já está em uso.',
		password: 'Sua senha deve ter 6 caracteres ou mais.',
		confirmationCode: 'Por favor, insira o código de confirmação.',
		documentType: 'Tipo de documento inválido',
		termsAndConditions: 'Você deve aceitar os termos e condições',
		amount: 'Por favor, selecione ou insira um valor válido.',
		signIn: 'Erro ao fazer login',
		emailsDoNotMatch: 'Os endereços de e-mail não coincidem.',
		passwordsDoNotMatch: 'As senhas não coincidem.',
		imageFormat: 'Por favor, solte um arquivo de imagem',
		camera: 'Não é possível acessar a câmera. Por favor, certifique-se de ter concedido permissão.',
		expiredCode: 'O código expirou.',
		codeMismatch: 'O código está incorreto. Por favor, tente novamente.',
		notAuthorized: 'Credenciais incorretas. Por favor, tente novamente.',
		userDoesNotExist: 'O usuário não existe.',
		userNotConfirmed: 'Usuário não confirmado. Por favor, confirme seu endereço de e-mail primeiro.',
		userAlreadyConfirmed: 'O usuário já foi confirmado.',
		documentNumberExists: 'O número do documento já está em uso.',
		limitExceeded: 'Você atingiu o limite de tentativas. Por favor, tente novamente mais tarde.',
		invalidPassword: 'A senha é inválida, deve ter pelo menos 6 caracteres e não pode conter espaços.',
		captchaFailed: 'CAPTCHA verification failed. Please try again.',
		internal: 'Desculpe, houve um problema, nossa equipe já foi informada, tente novamente mais tarde.',
	},
	documentTypes: {
		id: 'BI',
		passport: 'Passaporte',
		taxId: 'Identificação fiscal',
		nie: 'NIE',
		others: 'Outros',
	},
	labels: {
		code: 'Código',
		email: 'E-mail',
		repeatEmail: 'Repita seu e-mail',
		password: 'Senha',
		confirmPassword: 'Confirmar senha',
		amount: 'Valor da doação',
		documentType: 'Tipo de documento',
		documentNumber: 'Número do documento',
		name: 'Nome',
		lastName: 'Sobrenome',
		streetName: 'Nome da rua',
		streetNumber: 'Número',
		additionalInfo: 'Informação adicional',
		postalCode: 'Código postal',
		city: 'Cidade',
		country: 'País',
		region: 'Região',
		province: 'Província',
		certificate: 'Quero receber um certificado fiscal',
		termsAndConditions1:
			'Esta informação só será compartilhada com as organizações receptoras das suas doações para gerar o respectivo certificado fiscal. Leia os ',
		termsAndConditions2: 'termos e condições',
		language: 'Idioma',
	},
	checkout: {
		title: 'Método de pagamento',
	},
	recaptcha: {
		description: 'protegido por reCAPTCHA.',
		privacy: 'Privacidade',
		terms: 'Termos',
	},
	thanks: {
		title: 'Obrigado\n pela sua doação!',
		description:
			'Em breve você receberá um e-mail de confirmação com todos os detalhes. Juntos estamos construindo um futuro melhor!',
	},
	termsAndConditions: {
		title: 'Termos de Proteção de dados',
		labelText: 'Li, entendo e aceito os termos de ',
		labelLink: 'Proteção de Dados de {{name}}',
		accept: 'Li, entendo e aceito',
		responsible: {
			title: 'Responsável',
			description: 'WORLDCOO S.L.',
		},
		purpose: {
			title: 'Finalidade',
			description:
				'Gerir a relação comercial em todos os seus âmbitos, bem como a sua doação e o seu pedido de certificado, e o envio de comunicações comerciais por via eletrônica.',
			descriptionNgo:
				'A captação de fundos para projetos da ONG, mantê-lo informado sobre a ONG e a evolução do projeto para o qual doou fundos e a emissão de certificados de dedução fiscal.',
		},
		legitimacy: {
			title: 'Legitimidade',
			description: 'A base legal para o tratamento dos seus dados é a obtenção do seu consentimento.',
		},
		recipients: {
			title: 'Destinatários',
			description: 'Os dados não serão transferidos para terceiros, exceto se houver obrigação legal para isso.',
		},
		rights: {
			title: 'Direitos',
			description:
				'Tem o direito de aceder, retificar e eliminar os dados, bem como outros direitos, conforme explicado nas informações adicionais.',
		},
		additionalInfo: {
			title: 'Informações adicionais',
			description:
				'Pode consultar informações adicionais e detalhadas sobre Proteção de Dados na nossa página <a href="https://www.worldcoo.com/gdpr">web</a> ou bem contactando a <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>.',
			descriptionNgo:
				'Pode consultar as informações adicionais e detalhadas sobre Proteção de Dados no site de cada ONG.\n\n<b>{{ngoName}}</b>',
		},
	},
};
